/**
 * Ticket customer-email action handlers (web). Each opens the globally-mounted
 * SendTicketCustomerEmailModal (DetailPageModals) via the modal-stack data
 * payload — the modal POSTs to /api/tickets/[id]/customer-email itself, so
 * these handlers carry NO business logic and the modal reads NO
 * DetailActionContext (GLOBAL_MODAL_NO_ACTION_CONTEXT).
 */

import { MODAL_IDS } from "@wtc/ui";
import type { UniversalActionHandlers } from "./types";
import type { BaseEntity, DetailActionContext } from "../types/detailPage";

/** Build a customer-safe ticket label for the modal header. */
function ticketLabel(item: BaseEntity): string | undefined {
  const row = item as Record<string, unknown>;
  const num = typeof row.ticket_number === "number" ? `Ticket #${row.ticket_number}` : "Ticket";
  const title = typeof row.title === "string" && row.title.trim() ? ` — ${row.title.trim()}` : "";
  return `${num}${title}`;
}

function contactName(item: BaseEntity): string | undefined {
  const row = item as Record<string, unknown>;
  return typeof row.contact_name === "string" && row.contact_name.trim()
    ? row.contact_name.trim()
    : undefined;
}

function openSendModal(
  item: BaseEntity,
  context: DetailActionContext<BaseEntity>,
  kind: "acknowledgement" | "resolved" | "quick_reply"
): void {
  const row = item as Record<string, unknown>;
  context.onOpenModal(MODAL_IDS.tickets.sendCustomerEmail, {
    ticketId: item.id,
    kind,
    ticketLabel: ticketLabel(item),
    contactName: contactName(item),
    ticketNumber:
      typeof row.ticket_number === "number" || typeof row.ticket_number === "string"
        ? row.ticket_number
        : null,
    ticketTitle: typeof row.title === "string" ? row.title : null,
  });
}

export const ticketCustomerEmailActions: UniversalActionHandlers = {
  sendTicketAckEmail: (item, context) =>
    openSendModal(item, context, "acknowledgement"),
  sendTicketResolvedEmail: (item, context) =>
    openSendModal(item, context, "resolved"),
  sendTicketQuickReply: (item, context) =>
    openSendModal(item, context, "quick_reply"),
};
